import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getDatabase, ref as dbRef, onValue, off } from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://delivery-e172b-default-rtdb.firebaseio.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const database = getDatabase(app);

export const uploadFile = async (file, loanId, fileType = "collateral") => {
  const folder = fileType === "document" ? "documents" : "collateral";
  const storageRef = ref(storage, `${folder}/${loanId}/${file.name}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};

// Subscribe to real-time rider locations from Firebase Realtime Database
export const subscribeToRiderLocations = (callback, maxAgeMinutes = 5) => {
  const ridersRef = dbRef(database, 'driver_locations');

  const listener = onValue(ridersRef, (snapshot) => {
    console.log('Firebase snapshot received:', snapshot.exists());
    const riders = [];
    const now = Date.now();
    const maxAge = maxAgeMinutes * 60 * 1000; // Convert minutes to milliseconds

    if (snapshot.exists()) {
      const data = snapshot.val();
      console.log('Firebase raw data:', data);

      Object.keys(data).forEach((driverId) => {
        const driver = data[driverId];
        console.log('Processing driver:', driverId, driver);

        // Check if latLng exists and has valid coordinates
        if (driver && driver.latLng && driver.latLng.latitude && driver.latLng.longitude) {
          // Safely handle timestamp - ensure it's valid before converting
          let lastUpdate;
          const timestamp = driver.timestamp;

          console.log('Driver timestamp:', timestamp, 'Type:', typeof timestamp);

          try {
            // Check if timestamp is valid
            if (timestamp && typeof timestamp === 'number' && !isNaN(timestamp) && timestamp > 0) {
              const date = new Date(timestamp);
              // Verify the date is valid
              if (!isNaN(date.getTime())) {
                lastUpdate = date.toISOString();

                // Check if rider location is too old
                const age = now - timestamp;
                if (age > maxAge) {
                  console.warn(`Skipping stale rider ${driverId}: Last update ${Math.round(age / 60000)} minutes ago`);
                  return; // Skip this rider
                }
              } else {
                console.warn('Invalid date created from timestamp:', timestamp);
                return; // Skip invalid data
              }
            } else {
              console.warn('Invalid or missing timestamp:', timestamp);
              return; // Skip if no valid timestamp
            }
          } catch (e) {
            console.error('Error processing timestamp:', e);
            return; // Skip on error
          }

          const riderData = {
            id: driverId,
            name: driver.rider_name || driver.driver_id || 'Unknown Rider',
            latitude: parseFloat(driver.latLng.latitude),
            longitude: parseFloat(driver.latLng.longitude),
            timestamp: timestamp,
            debtorName: driver.debtor_name || 'N/A',
            debtorLocation: driver.debtor_location || 'N/A',
            lastUpdate: lastUpdate,
            status: 'active',
            ageMinutes: Math.round((now - timestamp) / 60000), // Age in minutes for display
            bearing: driver.bearing || driver.heading || 0 // Get bearing from Firebase, default to 0 (north)
          };

          console.log('Adding rider:', riderData);
          riders.push(riderData);
        } else {
          console.warn('Driver missing latLng or coordinates:', driverId, driver);
        }
      });
    } else {
      console.log('No Firebase data exists at driver_locations path');
    }

    console.log(`Total riders found: ${riders.length} (filtered out stale locations older than ${maxAgeMinutes} minutes)`);
    callback(riders);
  }, (error) => {
    console.error('Firebase onValue error:', error);
    callback([]);
  });

  // Return unsubscribe function
  return () => off(ridersRef, 'value', listener);
};
